import {
	GROWTH_KEYWORD,
	ON24_URL_KEYWORD,
	GROWTH_WORKFLOWS,
	THROUGHLINE_URL_KEYWORD,
	CCT_TODOLIST,
} from './growthConstants';
import { REACT_CONFIG } from './config';
import Url from '../../../utils/Url';

function getPathData() {
	const pathArray = window.location.pathname.split('/');
	return {
		path: pathArray[1],
		project: pathArray[2],
		product: pathArray[3],
		projectPage: pathArray[4],
	};
}

class GrowthUtils {
	/**
	 * [getIMSData consolidates the IMS data for the current user that is passed to the view]
	 * @return {Object} object containing IMS data for the current user
	 */
	config: any;
	workflow = '';

	hasFeature(feature: string) {
		return (
			window.cchome &&
			window.cchome.util &&
			window.cchome.util.hasFeature &&
			window.cchome.util.hasFeature(feature)
		);
	}

	getGrowthConfig(): any {
		this.workflow = this.getGrowthWorkflow();
		this.config = this.workflow !== GROWTH_WORKFLOWS.NOT_VALID ? REACT_CONFIG[this.workflow] : undefined;

		return this.config;
	}

	getGrowthWorkflow(): string {
		if (this.isON24Workflow()) {
			return GROWTH_WORKFLOWS.ON24;
		}

		if (this.isThroughlineWorkflow()) {
			return GROWTH_WORKFLOWS.THROUGHLINE;
		}

		if (this.isTodoWorkflow()) {
			return GROWTH_WORKFLOWS.TODOLIST;
		}

		if (this.isCctTodoWorkflow()) {
			return GROWTH_WORKFLOWS.CCT_TODOLIST;
		}

		return GROWTH_WORKFLOWS.NOT_VALID;
	}

	getIMSData() {
		let userId;
		if (window.adobeIMS.getUserProfile()) {
			userId = window.adobeIMS.getUserProfile()?.authId || window.adobeIMS.getUserProfile()?.userId;
		}
		const imsData = {
			token: window.adobeIMS.getAccessToken(),
			firstName: window.adobeIMS.getUserProfile() ? window.adobeIMS.getUserProfile()!.first_name : null,
			lastName: window.adobeIMS.getUserProfile() ? window.adobeIMS.getUserProfile()!.last_name : null,
			email: window.adobeIMS.getUserProfile() ? window.adobeIMS.getUserProfile()!.email : null,
			userId,
		};

		return imsData;
	}

	hideCCInstallationDialog() {
		return this.isON24Workflow() || this.isThroughlineWorkflow() || this.isCctTodoWorkflow();
	}

	isGrowthWorkflow() {
		// checks for all the growth workflows
		return (
			this.isON24Workflow() || this.isThroughlineWorkflow() || this.isTodoWorkflow() || this.isCctTodoWorkflow()
		);
	}

	isON24Workflow() {
		if (window.cchome.util.hasFeature('temp_enable_webcast_workflow')) {
			const { path, project } = getPathData();
			if (path === GROWTH_KEYWORD && project === ON24_URL_KEYWORD) {
				return true;
			}
		}
		return false;
	}

	isThroughlineWorkflow() {
		const { path, project, product } = getPathData();
		if (this.hasFeature('temp_enable_throughline_workflow')) {
			if (path === 'apps' && project === THROUGHLINE_URL_KEYWORD && product === 'photoshop') {
				return true;
			}
		}

		return false;
	}

	isTodoWorkflow() {
		const { path, project, product, projectPage } = getPathData();
		if (this.hasFeature('temp_enable_todo_workflow')) {
			if (path === 'apps' && project === 'get-started' && product === 'photoshop' && projectPage === 'todo') {
				return true;
			}
		}
		return false;
	}

	isCctTodoWorkflow() {
		const { path, project } = getPathData();
		if (this.hasFeature('temp_enable_cct_todo_workflow')) {
			if (path === GROWTH_KEYWORD && project === CCT_TODOLIST) {
				return true;
			}
		}
		return false;
	}

	getThroughlineType() {
		const type = Url.getParam('type');
		if (window.cchome.util.hasFeature('temp_enable_throughline_v3_workflow') && type !== null) {
			return type;
		}
		return '';
	}

	isUrlParamTrue(param: string) {
		return Url.getParam(param) && Url.getParam(param) === 'true';
	}
}

export default new GrowthUtils();
